import React from "react"
import {iconClose} from "../Helper/Icons"
import style from "./Button.css"

export const Button = ({children, onClick, isDisabled = false, className = ''}) => {
    return <button className={`${style.button} ${className}`} onClick={onClick} disabled={isDisabled}>{children}</button>
}

export const ButtonShy = ({children, onClick, isDisabled = false}) => {
    return <button className={style.buttonShy} onClick={onClick} disabled={isDisabled}>{children}</button>
}

export const ButtonRed = ({children, onClick, isDisabled = false}) => {
    return <button className={style.buttonRed} onClick={onClick} disabled={isDisabled}>{children}</button>
}

export const ButtonClose = ({onClick}) => {
    return <button className={style.buttonClose} onClick={onClick}>{iconClose}</button>
}

export const ButtonText = ({children, onClick, isDisabled = false}) => {
    return <button className={style.buttonText} onClick={onClick} disabled={isDisabled}>{children}</button>
}